export const CUSTOM_FILTERS_SELECTOR = '.dataTables_custom_filter';
export const DATATABLES_SELECTOR = 'table.dataTables';
export const PJAX_MAIN_CONTAINER_ID = 'pjax-main';
export const PJAX_MAIN_CONTAINER_SELECTOR = `#${PJAX_MAIN_CONTAINER_ID}`;
export const PJAX_EVENTS_CONTAINER_ID = 'pjax-sequential_events';
export const PJAX_EVENTS_CONTAINER_SELECTOR = `#${PJAX_EVENTS_CONTAINER_ID}`;
export const PJAX_TRANSITION_CONTAINER_ID = 'pjax-consultation_transition';
export const PJAX_TRANSITION_CONTAINER_SELECTOR = `#${PJAX_TRANSITION_CONTAINER_ID}`;
export const SPLIT_CONTENT_CONTAINER_ID = 'split-page__content';
export const RTC_IFRAME_ID = 'rtc-iframe';
export const CONSULTATION_CREATE_NOTIFICATION = 'consultation_create';

export const NAVBAR_HEIGHT = 50;
export const DROPDOWN_ARROW_ANIMATION_TRANSITION = 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
export const SCREEN_XS = 768;
export const SCREEN_XS_PX = `${SCREEN_XS}px`;
export const SCREEN_SM = 992;
export const SCREEN_SM_PX = `${SCREEN_SM}px`;
export const SIDE_PANEL_AUTO_REDUCE_MAX_WIDTH = 900; // In px.

// CALENDAR CONFIG
export const CALENDAR_DAY_START = new Date(2017, 10, 0, 0, 0, 0); // From 00:00 AM.
export const CALENDAR_DAY_END = new Date(2017, 10, 0, 23, 59, 59); // To 24:00 PM.

// Minimum amount of minutes for each calendar 'step'.
// Since we are dividing hours, this needs to be a factor of 60.
export const MINUTES_PER_STEP = 15;
export const STEPS_PER_HOUR = 60 / MINUTES_PER_STEP; // NOTE: As long as 60 % MINUTES_PER_STEP == 0, this does not need to change.

// CALENDAR VIEWS
export const CALENDAR_VIEWS = {
  DAY: 'day',
  WEEK: 'week',
  PLANNING: 'planning',
};
